<template>
    <div>
         <el-form>
        	<!-- <el-form-item class="btnArea">
                <el-upload ref="upload"  style="display: inline-block;" :show-file-list="false" 
                :action="uploadUrl('sim/other/batch/insert/sim/state')" :headers="setHeader()" 
                :limit="1"  :on-success = "handleSuccess">
                    <el-button slot="trigger" plain>增加卡号</el-button>
                </el-upload> 
            </el-form-item> -->
            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible = true" >批量屏蔽卡</el-button>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-upload ref="upload"  style="display: inline-block;" :show-file-list="false" 
                :action="uploadUrl('sim/other/batch/delete/state/state')" :headers="setHeader()" 
                :limit="1"  :on-success = "handleSuccess">
                    <el-button slot="trigger" plain>删除卡号</el-button>
                </el-upload> 
            </el-form-item>
            <el-form-item class="btnArea">
                <el-upload ref="upload"  style="display: inline-block;" :show-file-list="false" 
                :action="uploadUrl('sim/other/batch/insert/sim/month')" :headers="setHeader()" 
                :limit="1"  :on-success = "handleSuccess">
                    <el-button slot="trigger" plain>批量导入12个月流量（临时）</el-button>
                </el-upload> 
            </el-form-item>
            <el-button>    <a  class="export-tamplate" href="../../../doc/batchselctct.xls" download="卡片导入模板.xls">下载模板/仅限iccid</a></el-button> 
             <el-form-item label="所属代理商：">
                <el-select v-model="searchForm.agentId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in agentsOption" :value="item.agentId" :key="item.agentId" :label="item.agentName"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" class="el-input__inner"></el-input>
            </el-form-item>
        <el-button type="primary" class="onlyBtn" @click="getImportRecordListHandle">查询</el-button>
        </el-form>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column type="index" label="序号"  ></el-table-column>
            <el-table-column prop="iccid" label="iccid"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" ></el-table-column>
            <el-table-column prop="agentId" label="代理商" ></el-table-column>
            <el-table-column prop="agentPathId" label="代理商路径" ></el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">          
                <el-form-item label="导入批次号" prop="voiceGroupId">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="importCardForm.num"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="getExcels">确 定</el-button>
            </div> 
        </el-dialog> 
        
        <el-dialog title="批量屏蔽" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/other/batch/insert/sim/state')" :headers="setHeader()" :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success = "handleSuccess" :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>                        
                </el-form-item>  
                <el-form-item label="备注：" width="80" prop="remark">
                    <el-input v-model="importCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog title="导入失败卡列表" :visible.sync="importFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import {oneCardImport, getImportRecordList, getImportFailRecordList,getImportRecordList5,getImportRecordList2} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){   
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if(len > 0){
                var extName = files[0].name.split('.')[1].toLowerCase();
                if(extName != 'xls' && extName != 'xlsx'){
                    return callback(new Error('请选择要导入的Excel文件'));
                }else{
                    callback();
                }
            }else{
                return callback(new Error('请选择要导入的Excel文件'))
            }           
        }
        return {   
            importCardVisible: false,
             agentsOption: [],  
            searchForm: {
                agentId:'',
                iccid: ''
            },       
            agentAccountForm: {
                name: '',
                sysUserAccountName: '',
                accountState: ''
            },
            importCardForm: {
                simType: '0',
                cardCategory: 'MP',
                supplierId: '',
                agentId: '',
                simPoolId: '',
                simLife: '',
                isVoice:'',
                num:'',
                remark:''
            },
            importCardVisible: false,
            importFailVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },       
            currentId_fail: '',
            supplierOption: [],
            agentsOption: [],
            fluxPoolOption: [],
            title: '',
            importCardRules: {
                uploadExcel: [{required: true, validator: checkImportFile}],
                iccid: [{required: true, validator: this.checkIccid, trigger: 'blur'}],
                intoNo: [{required: true, validator: this.checkIntoNo, trigger: 'blur'}],
                supplierCode: [{required: true, message: '请选择供应商', trigger: 'change'}],
                basePkgGroup: [{required: true, message: '请选择套餐组', trigger: 'change'}],
                cardType: [{required: true, message: '请选择卡类型', trigger: 'change'}]
            }
        }
    },
    methods: {

        cancel(){            
            this.importCardVisible = false; 
            this.$refs.importCardForm.resetFields();
        },
        handleChange(file, fileList){
            if(fileList.length > 0){
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },
        getImportRecordListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', {iccid:this.searchForm.iccid,agentId:this.searchForm.agentId});
            getImportRecordList5(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getImportFailRecordListHandle(id, $event){
            this.importFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getImportFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showManyCardImport(){
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "批量导入";
        },
        getOptionsOfSelect(){       
            common.getSupplierOptsCom(this, 'supplierOption');    
            common.getNextAgentOptsCom(this, 'agentsOption');       
        },
        changeAgent(){
            this.importCardForm.simPoolId = '';
            var data = {
                id: this.importCardForm.agentId
            }
            common.getFluxPoolOptsCom(this, 'fluxPoolOption', data)
        },
        sureImportCardHandle(){
            this.$refs.importCardForm.validate(valid => {
                if(valid){
                    this.$refs.upload.submit();   //号段批量导入
                }
            })           
        },
         getExcels(){
            var data = JSON.parse(JSON.stringify(this.importCardForm));
            data.token = localStorage.getItem('token');
            data.num=this.importCardForm.num;
            data.pageSize = 10000;
            data.prePageNum = 10000;
            this.exportExcel('/sim/other/batch/select/sim/iccid', data);
            this.$message.success('下载中……');
              this.importCardVisible = false; 
        },
        exportHandle(){//导出excel文件
            var data = {};
            data.token = localStorage.getItem('token');
            this.exportExcel('/excel/sim/template', data);
            this.$message.success('下载中……');
        },
        handleSuccess(res){
            if(res.code == 200){
                this.importCardVisible = false;
                 this.$refs.upload.clearFiles();
                this.getImportRecordListHandle();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getImportRecordListHandle();
            }
        },
        handleCurrentChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getImportRecordListHandle();
            }
        }  
    },
    created () {
        this.getImportRecordListHandle();
         common.sysRequest('/agent/listOption', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.agentsOption = res.data.data;
            }

        });
    } 
}
</script>

<style lang="less" scoped>
.el-input__inner {
    width: 30%;
}
</style>

